<template>
  <div class="panel-item">
    <div class="title_name">机构销售榜单</div>
    <div class="panel-item_box">
      <div @click="list_clk(item)" v-for="(item, index) in list" :key="index" class="panel-item_list">
        <img class="panel-item_img" v-if="(item.value === activeTab)" src="../../../../assets/true.png"
          mode="scaleToFill" />
        <img class="panel-item_img" v-else src="../../../../assets/false.png" mode="scaleToFill" />
        <div class="panel-item_name">{{ item.name }}</div>
      </div>
    </div>
    <!-- 胶囊柱状图 -->
    <dv-capsule-chart :config="config" class="panel-item_chart" />
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      list: [
        { name: '付款订单总数', value: 1 },
        { name: '付款订单总金额', value: 2 },
        { name: '结算订单总数', value: 3 },
        { name: '结算订单总金额', value: 4 },
      ],
      activeTab: 1,
      rank_list: [],
      config: {
        data: [],
        unit: '',
        showValue: true,
        fontSize: 12
      }
    }
  },
  watch: {
    datas: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.pay_order_rank_list) {
          this.rank_list = newVal.pay_order_rank_list
          this.updateChartData()
        }
      }
    },
    rank_list: {
      handler(newVal) {
        this.updateChartData()
      }
    }
  },
  methods: {
    list_clk(item) {
      this.activeTab = item.value
      switch (this.activeTab) {
        case 1:
          this.rank_list = this.datas.pay_order_rank_list || []
          break
        case 2:
          this.rank_list = this.datas.pay_gmv_rank_list || []
          break
        case 3:
          this.rank_list = this.datas.settle_order_rank_list || []
          break
        case 4:
          this.rank_list = this.datas.settle_gmv_rank_list || []
          break
      }
    },
    formatNumber(num) {
      return '123'
      if (num >= 1e8) return (num / 1e8).toFixed(2) + '亿'
      if (num >= 1e4) return (num / 1e4).toFixed(2) + '万'
      return num.toString()
    },
    updateChartData() {
      if (!this.rank_list || this.rank_list.length === 0) return;

      const newData = this.rank_list.map(item => {
        const value = parseFloat(item.census_value) || 0;
        return {
          name: item.institution_name,
          value,
          displayValue: this.formatNumber(value)
        }
      });

      this.config = {
        data: newData,
        unit: '',
        showValue: true,
        fontSize: 12
      }

      this.$nextTick(() => {
        if (this.$refs.capsuleChart?.updateChart) {
          this.$refs.capsuleChart.updateChart();
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;
  padding: 0 20px;
  box-sizing: border-box;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.title_name {
  padding: 30px 0 23px 80px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}

.panel-item_list {
  display: flex;
  margin-bottom: 27px;
  cursor: pointer;
  align-items: center;
}

.panel-item_img {
  width: 30px;
  height: 20px;
  margin-right: 10px;
}

.panel-item_name {
  font-weight: 400;
  font-size: 18px;
  color: #AEE6FF;
  line-height: 20px;
  white-space: nowrap;
}

.panel-item_box {
  padding: 0 60px 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.panel-item_chart {
  padding-top: 0 !important;
  width: calc(100% );
  height: 200px;
  line-height: 18px !important;
  overflow: scroll;
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE和Edge */
}

::v-deep .capsule-item {
  // padding-left: 14px !important;
  width: 240px !important;
  //margin-bottom: 30px !important;
  box-shadow: none !important;
}

// label 文本呢
::v-deep .dv-capsule-chart .label-column div {
  //height: 24px !important;
  line-height: 28px !important;
  font-weight: 400;
  font-size: 18px !important;
  color: #FEFEFF !important;
}

// 柱形
::v-deep .capsule-item-column {
  border-radius: 10px !important;
  height: 18px !important;
  //line-height: 18px !important;
}

//柱形右侧label
::v-deep .capsule-item-value {
  font-size: 18px !important;
  color: #3DFDFF !important;
  //min-width: 60px;          /* 最小宽度 */
  //width: auto;              /* 宽度自适应 */
  //max-width: 80px;         /* 最大宽度限制 */
  //overflow: hidden;          /* 隐藏溢出内容 */
  //text-overflow: ellipsis;   /* 显示省略号 */
}

// x轴隐藏
::v-deep .unit-label {
  opacity: 0 !important;
}



::v-deep .capsule-item:nth-child(1) .capsule-item-column {
  background: linear-gradient(90deg, #040B2A, #468CFF) !important;
}

::v-deep .capsule-item:nth-child(2) .capsule-item-column {
  background: linear-gradient(90deg, #040B2A, #FFA146) !important;
}

::v-deep .capsule-item:nth-child(3) .capsule-item-column {
  background: linear-gradient(90deg, #040B2A, #e690d1) !important;
}

::v-deep .capsule-item:nth-child(4) .capsule-item-column {
  background: linear-gradient(90deg, #040B2A, #1ED5D7) !important;
}

::v-deep .capsule-item:nth-child(5) .capsule-item-column {
  background: linear-gradient(90deg, #040B2A, #D2B233) !important;
}

</style>